import React, { Component, useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import OfferDetailView from './OfferDetailView'
import crmservices from '../../wsclient/crmservices';
const styles = theme => ({

});
function OfferDetail(props){
    const [offerItem, setOfferItem] = useState(null);
    const [zoomMap, setZoomMap] = useState(7.5);
    const [direction, setDirection] = useState(null);
    const [region, setRegion] = useState({
        latitude: 35.157322,
        longitude: 33.313751,
        latitudeDelta: 0.015,
        longitudeDelta: 0.0121,
    });
    const [centerRegion, setCenterRegion] = useState(null);
    const [showLoading, onShowLoading] = useState(false);
    const [showDirection, onShowDirection] = useState(null);
    const initialRegion = {
        lat: 35.157322,
        lng: 33.313751,
    };

    useEffect(()=>{
        onShowOfferDetail()
    },[]);

    const onShowOfferDetail = async() => {
        
        const offer = props.offer
      //  console.log('onShowOfferDetail offer=== ',offer)
        if (offer&&offer.owned_by && offer.owned_by.id) {

            onShowLoading(true);
            
            try {
                let result = await crmservices.rewards.getOrganisationDetail(offer.owned_by.id);
               // console.log("getOrganisationDetail result:", result);
                if (result.code == 'OK') {
                    offer.phone_number = getContactPhone(result.data.contact_info);
                    offer.industry_name = result.data.industry_name;
                    offer.industry_sectors = result.data.industry_sectors;
                }
                let locationsResult = await crmservices.rewards.getOrgLocations({},offer.owned_by.id);
             //   console.log("locationsResult result:", locationsResult);
                if (locationsResult.code == 'OK') {
                    if (locationsResult.data.content && locationsResult.data.content.length > 0) {
                        offer.venues = locationsResult.data && locationsResult.data.content ? locationsResult.data.content : null;
                    } else {
                        if (result.data.locations && result.data.locations.length > 0) {
                            offer.venues = [{ locations: result.data.locations }];
                        }
                    }
                }
            } catch (error) {
                console.log("get store info exception:", error);
            }
            //console.log("offer Item:", offer);
            onShowLoading(false);
            setOfferItem(offer);
        }
        
    }
    const getContactPhone = (contact_info) => {
        let phone_number = "";
        if(contact_info && contact_info.length > 0){
            let phones = contact_info.filter(contact => {
                return contact.type==='PHONE';
            })
            if(phones && phones.length > 0){
                phone_number = phones[0].value;
            }
        }
        return phone_number;
    }

    const onSelectMerchant = (merchant) => {
        //console.log(' merchant========', merchant)
        let location = merchant.locations && merchant.locations.length > 0 ? merchant.locations[0] : null;
        if (location.lat && location.lon) {
            onShowDirection(true);
            setDirection(location);
            setCenterRegion(location);
            setZoomMap(12);
        }
    }
    const onDirection = () => {
        if (direction) {
            let url = 'https://www.google.com/maps/search/?api=1';
            if (direction.lat && direction.lon) {
                url = url + '&query=' + direction.lat + "," + direction.lon;
            }
            if (direction.googleplaceid) {
                url = url + '&query_place_id=' + direction.googleplaceid;
            }
            console.log("url:", url);
            window.open(url)
            //Linking.openURL(url);
            // openMap({ end: direction.lat + "," + direction.lon, provider: provider });
        }
    }
        return (
            <div>
                <OfferDetailView
                        showLoading = {showLoading}
                        offer={offerItem}
                        onCloseOfferDetail={props.onCloseOfferDetail}
                        onSelectMerchant={onSelectMerchant}
                        open={props.open}
                        onClose = {props.handleDrawerToggle}
                        onShowOfferDetail = {onShowOfferDetail}
                        centerRegion={centerRegion}
                        zoomMap={zoomMap}
                        showDirection={showDirection}
                        onDirection={onDirection}/>
            </div>
        );
}

export default withStyles(styles)(withTranslation()(OfferDetail));